function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: 16.08,
  x2: 45.52,
  y1: 57.43,
  y2: 164.85
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0a7982"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#0a7982"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#00a79d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#5ba982"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#56a983"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  stopColor: "#37a88d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#1fa894"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#0ea799"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#03a79c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#00a79d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.86,
  stopColor: "#08a99b",
  stopOpacity: 0.98
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.91,
  stopColor: "#20af95",
  stopOpacity: 0.92
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.96,
  stopColor: "#47b98c",
  stopOpacity: 0.82
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#74c481",
  stopOpacity: 0.7
}));

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  gradientUnits: "userSpaceOnUse",
  x1: 16.08,
  x2: 45.52,
  y1: 57.43,
  y2: 164.85
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0a7982"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#0a7982"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#127b82"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#0e8689",
  stopOpacity: 0.88
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#00a79d",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#5ba982",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#67b682",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#71c181",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.91,
  stopColor: "#74c481",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#74c481"
}));

var _ref4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  gradientUnits: "userSpaceOnUse",
  x1: 49.56,
  x2: 106.88,
  y1: 112.89,
  y2: 53.39
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00a79d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.52,
  stopColor: "#74c481",
  stopOpacity: 0.9
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#74c481",
  stopOpacity: 0.9
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M122.82 148.88H12.11a7.24 7.24 0 01-7.24-7.24V30.93a7.25 7.25 0 017.24-7.24h110.71a7.25 7.25 0 017.24 7.24v110.71a7.24 7.24 0 01-7.24 7.24zM13.7 140.05h107.53V32.52H13.7z",
  fill: "#a0cf6a",
  opacity: 0.8
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M57.38 127.38c-2.38 2.73-4.7 5.51-7.14 8.19A15.73 15.73 0 0137.38 141a15.9 15.9 0 01-13.9-8.72c-2.55-4.66-5-9.39-7.5-14-2.3-4.21-4.53-8.46-6.79-12.7C8 103.3 6.82 101 5.64 98.79A14.1 14.1 0 014 92.09a14.39 14.39 0 0126.4-7.89q5.18 7.62 10.32 15.26",
  fill: "url(#a)",
  transform: "translate(-4 -5.18)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M57.38 127.38c-2.38 2.73-4.7 5.51-7.14 8.19A15.73 15.73 0 0137.38 141a15.9 15.9 0 01-13.9-8.72c-2.55-4.66-5-9.39-7.5-14-2.3-4.21-4.53-8.46-6.79-12.7C8 103.3 6.82 101 5.64 98.79A14.1 14.1 0 014 92.09a14.39 14.39 0 0126.4-7.89q5.18 7.62 10.32 15.26",
  fill: "url(#a)",
  transform: "translate(-4 -5.18)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M57.38 127.38c-2.38 2.73-4.7 5.51-7.14 8.19A15.73 15.73 0 0137.38 141a15.9 15.9 0 01-13.9-8.72c-2.55-4.66-5-9.39-7.5-14-2.3-4.21-4.53-8.46-6.79-12.7C8 103.3 6.82 101 5.64 98.79A14.1 14.1 0 014 92.09a14.39 14.39 0 0126.4-7.89q5.18 7.62 10.32 15.26",
  fill: "url(#b)",
  transform: "translate(-4 -5.18)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M40.72 99.46c.46.68.46.66 1.05.14Q48.4 93.76 55 87.94l12-10.63c3.48-3.06 6.92-6.16 10.44-9.17a12 12 0 0115.06 0A11.83 11.83 0 0195 84a35.94 35.94 0 01-3.08 3.68q-5.42 6.23-10.83 12.42l-10.63 12.22-13.08 15.06",
  fill: "url(#c)",
  transform: "translate(-4 -5.18)"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 102.62,
  cy: 50.69,
  fill: "#9ac96c",
  r: 10.49
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 123.78,
  cy: 28.78,
  fill: "#9ac96c",
  r: 9.02
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 145.25,
  cy: 8.09,
  fill: "#9ac96c",
  r: 8.09
});

var SvgLogoSecondary = function SvgLogoSecondary(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 153.35 148.88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoSecondary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logoSecondary.e419f253.svg";
export { ForwardRef as ReactComponent };